<script lang="ts" setup>
import { useEventListener } from "@vueuse/core";
import { computed, HTMLAttributes, reactive, toRef } from "vue";
import { provideSearchContext, SEARCH_KEYBOARD_SHORTCUT } from "./utils";

const props = withDefaults(defineProps<{
  defaultOpen?: boolean
  open?: boolean
  class?: HTMLAttributes['class']
}>(), {
  defaultOpen: false,
  open: undefined,
})

const state = reactive({
  open: props.open ?? props.defaultOpen ?? false,
  state: computed(() => state.open ? 'open' : 'closed'),
})

function setOpen(value: boolean) {
  state.open = value;
}

function toggleSearch() {
  state.open = !state.open;
}

useEventListener("keydown", (event: KeyboardEvent) => {
  if (event.key === SEARCH_KEYBOARD_SHORTCUT && (event.metaKey || event.ctrlKey)) {
    event.preventDefault();
    toggleSearch();
  }
});

provideSearchContext({
  state,
  open: toRef(() => state.open),
  setOpen,
  toggleSearch,
})
</script>

<template>
  <slot></slot>
</template>
